import { SxProps, Theme } from '@mui/material';
import { borderRadius, palette, spaces } from '../assets/styles/themes/tokens';

export const SEARCH_ICON_VIEW_BOX = '0 0 17 17';

export const searchIconSx = {
  width: 20,
  height: 20,
  color: palette.text.secondary,
} as const;

export const searchInputSx: SxProps<Theme> = {
  height: 40,
  paddingRight: `${spaces.md}!important`,
  paddingTop: `${spaces.xxs}!important`,
  paddingBottom: `${spaces.xxs}!important`,
  borderRadius: borderRadius.full,
  backgroundColor: palette.background.default,
  '&:hover': {
    backgroundColor: palette.background.paperElevation1,
  },
  '&.Mui-focused': {
    backgroundColor: palette.background.paperElevation1,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: `1px solid ${palette.primary.outlinedBorder}`,
  },
};
